export default function About() {
	return (
		<div className="flex justify-center h-full w-full bg-white ">
			About Page
		</div>
	);
}
